import React, { PureComponent } from 'react';
import Classnames from 'classnames';
import axios from 'axios';
import Dropzone from 'react-dropzone';
import * as XLSX from 'xlsx';
import Papa from 'papaparse';
import './Uploader.css';

class Uploader extends PureComponent {

    static defaultProps = {
        checkTickersUrl: 'https://dpd.wisdomtree.com/api/securityfund/ticker_names/',
        updateHoldings: null, // Method called when holdings are updated 
        placeholderLabel: null,
        token: null,
        totalValue: 1000000,
        downloadTemplateLabel: 'Download Template',
        downloadTemplateTooltipLabel: 'Download an example Excel template you can update with your tickers.',
        uploadFailureLabel: 'The following tickers could not be found: ',
    };

    constructor(props) {
        super(props);

        this.handleUpload = this.handleUpload.bind(this);

        // Set up local state
        this.state = {
            failuredFunds: null,
        }
    }

    // Handle upload of a portfolio
    handleUpload(acceptedFiles) {

        const reader = new FileReader();

        reader.onabort = () => console.log('file reading was aborted')
        reader.onerror = () => console.log('file reading has failed')
        reader.onload = () => {

            const binary = reader.result;

            const wb = XLSX.read(binary, { type: 'binary' });
            const ws = wb.Sheets[wb.SheetNames[0]];

            const file_contents = Papa.parse(XLSX.utils.sheet_to_csv(ws).replace(/\s+,/g, ','));
            var holdings = file_contents.data.filter(function (holding) {
                return holding[0] !== null && holding[0].toLowerCase() !== 'tickers' && holding[0].length > 0;
            }).map(function (holding) {
                return (holding)
            })

            // Check the tickers provided against the API
            this.checkTickers(holdings);

        }
        reader.readAsBinaryString(acceptedFiles[0]);

    };

    async checkTickers(holdings) {

        const {
            token,
            totalValue,
        } = this.props;

        const {
            updateHoldings,
            checkTickersUrl
        } = this.props;

        const tickers = holdings.map(holding => {
            return holding[0];
        })

        const weights = holdings.map(holding => {
            return holding[1];
        })

        // Convert the weights to numbers so we can sum them up
        const weightsAsNumbers = holdings.map(holding => {
            return +holding[1].replace(/[^0-9.-]+/g, '');
        })

        const totalWeight = weightsAsNumbers.reduce(function sumofArray(sum, num) {
            return sum + num;
        });

        const request = {
            method: 'POST',
            url: checkTickersUrl,
            data: JSON.stringify({ tickers }),
            headers: {
                'Content-Type': 'application/json',
                Authorization: token &&
                    `Token ${token}`,
            },
        };

        axios(request)

            .then((response) => {

                if (response.status === 200) {

                    const data = response.data;

                    let results = [];
                    let failures = [];

                    data.tickers.forEach((ticker, i) => {

                        const weightColType = weights[i].includes('%') ? 'weight' : 'amount';

                        const weight = weights[i].includes('%')
                            ? (+weights[i].replace(/[^0-9.-]+/g, '') / 100)
                            : +weights[i].replace(/[^0-9.-]+/g, '')

                        const row = {
                            ticker,
                            name: data.names[i],
                            amount: weightColType === 'weight' ?
                                (weight) * totalValue :
                                weight,
                            externalID: data.externalIDs[i],
                            weight: weightColType === 'weight' ?
                                +weights[i].replace(/[^0-9.-]+/g, '') / 100 :
                                +weights[i].replace(/[^0-9.-]+/g, '') / totalWeight,
                        }

                        // Add the fund to the result set
                        if (row.name !== 'UNKNOWN') {
                            results.push(row);
                        } else {
                            failures.push(row);
                        }

                    });

                    if (failures.length > 0){

                        // Update the failed funds
                        this.setState({
                            failuredFunds: failures,
                        });

                        // Remove the failed funds notice after 10 secs
                        setTimeout(() => this.setState({
                            failuredFunds: null,
                        }), 5000);
                    }

                    if (results.length === 0) {
                        return;
                    }

                    // Send back to the passed in function
                    updateHoldings(results);
                }
            })
            .catch((error) => {
                console.error(error);
            });

    };

    render() {

        const {
            downloadTemplateLabel,
            downloadTemplateTooltipLabel,
            placeholderLabel,
            uploadFailureLabel,
        } = this.props;

        const {
            failuredFunds,
        } = this.state;

        let failedFundsString = '';

        // Set up a string of failed fund tickers
        if (failuredFunds) {            

            failuredFunds.forEach(fund => {
                failedFundsString = failedFundsString + fund.ticker + ', ';
            });

            failedFundsString = failedFundsString.slice(0, -2);
        }

        return (
            <div>
                <div className='uploader-hub'>
                    <div className='dropzone-hub-container'>
                        <Dropzone
                            onDrop={acceptedFiles => {
                                console.log(acceptedFiles)
                                this.handleUpload(acceptedFiles)
                            }
                            }
                        >
                            {({ getRootProps, getInputProps }) => (
                                <section className='dropzone-section'>
                                    <div {...getRootProps()} className='dropzone'>
                                        <input {...getInputProps()} />
                                        <p>{placeholderLabel}</p>
                                    </div>
                                </section>
                            )}
                        </Dropzone>
                    </div>
                    <div className='template'>
                        <a 
                            title={downloadTemplateTooltipLabel} 
                            href='https://www.wisdomtree.com/-/media/us-media-files/advisor-solutions/digital-portfolio-developer/xls/capgainstemplate.xlsx' 
                            _target='blank'>{downloadTemplateLabel}</a>
                    </div>
                    
                    {/* Show any tickers that failed to load */}                
                    <div className={Classnames('failures', failuredFunds ? 'show' : '')}>
                        {uploadFailureLabel}<span className='tickers'>{failedFundsString}</span>
                    </div>
                    
                </div>
            </div>
        );
    }

}

export default (Uploader);